<template>
    <div    class="">
        <!-- Above Table Search & Items / Page Select -->
        <div class="py-4 grid grid-cols-1 md:grid-cols-3 flex flex-row">
            <!-- Company Select Component -->
            <div    v-if="Object.keys(companyList).length > 1"
                    class="mx-4 mb-2 flex flex-row md:col-span-2 items-center justify-start">
                <div class="flex flex-col justify-around w-full">
                    <div class="flex flex-col justify-between md:flex-row md:items-center">
                        <div class="w-full md:w-1/2 flex flex-col md:flex-row justify-center md:items-center">
                            <span   class="shrink-0">Select only</span>
                            <div    class="w-full md:ml-4">
                                <select2    name="companySelect"
                                            :options="companyList"
                                            :allow-clear="true"
                                            :close-on-select="true"
                                            v-model:value="selectedCompany"
                                ></select2>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <!-- Search Component -->
            <div class="mx-4 mb-2 flex flex-col md:flex-row md:col-span-2 items-center">
                <div class="flex flex-col justify-around w-full md:w-1/2">
                    <div class="flex flex-col justify-between md:flex-row md:items-center">
                        <div class="w-full">
                            <floating-input
                                    label="Search"
                                    v-model:value="search"
                            ></floating-input>
                        </div>
                    </div>
                </div>

                <!-- Create User Button -->
                <div    v-if="permissions.can('create_users')"
                        class="self-start flex items-center w-full md:w-auto ml:0 md:ml-2">
                    <green-button   :href="company.buildCompanyRoute('users/create')"
                    >
                        <div    class="inline-flex">
                            <span   class="lnr icon-plus-circle mr-2"></span>
                            <span>Create User</span>
                        </div>
                    </green-button>

                </div>

                <div    v-if="permissions.can('import_users')"
                        class="self-start flex items-center w-full md:w-auto ml:0 md:ml-2">
                    <button-blue-secondary   :href="company.buildCompanyRoute('import-users')"
                    >
                        <div    class="inline-flex">
                            <span   class="lnr icon-upload2 mr-2"></span>
                            <span>Import Users</span>
                        </div>
                    </button-blue-secondary>

                </div>
            </div>

            <!-- Items Per Page -->
            <div class="flex flex-row justify-start md:justify-end">
                <items-per-page-select  v-model:items-per-page="itemsPerPage"
                                        :current-low="pageInfo.from"
                                        :current-high="pageInfo.to"
                                        :total-results="pageInfo.total"
                ></items-per-page-select>
            </div>
        </div>

        <!-- Table -->
        <div class="bg-white shadow overflow-hidden sm:rounded-md border">
            <ul class="m-0">
                <!-- Header Row -->
                <li>
                    <div class="block flex justify-around text-gray-500 bg-gray-50 font-semibold grid grid-cols-1
                        hover:bg-gray-50 focus:outline-none focus:bg-gray-50 border"
                         :class="[showNotifications ? 'sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4' : 'md:grid-cols-2 xl:grid-cols-3',
                                    permissions.can('login_as_other_user') ? 'pr-16' : '']">
                        <div    class="cursor-pointer inline-block col-span-1 grow flex items-center px-4 py-4 sm:px-6 "
                                @click="updateSort('name')">
                            <span class="pr-2">Company</span>
                            <span v-show="sortBy ==='name'" :class="sortDesc ? iconSortDesc : iconSortAsc"></span>
                        </div>
                        <div    v-if="showNotifications"
                                class="hidden sm:inline-block grow px-4 py-4 sm:px-6 ">
                            <span class="pr-2">Notifications</span>
                        </div>
                        <div    class="cursor-pointer inline-block col-span-1 grow flex items-center px-4 py-4 sm:px-6 "
                                @click="updateSort('permission_level')">
                            <span class="pr-2">Permission Level</span>
                            <span v-show="sortBy ==='permission_level'" :class="sortDesc ? iconSortDesc : iconSortAsc"></span>
                        </div>
                        <div class="hidden xl:inline-block grow px-4 py-4 sm:px-6 ">
                            <span class="pr-2">Last Logged In</span>
                        </div>
                    </div>
                </li>

                <!-- Normal Row -->
                <li v-if="loading">
                    <div class="flex flex-row items-center justify-center py-4">
                        <span :class="iconLoading"></span>
                        <span class="text-grey-500 text-base font-medium">Loading</span>
                    </div>
                </li>
                <li v-else-if="users.length > 0" v-for="(user, userIndex) in users"
                    :class="{'bg-gray-200' : userIndex % 2 === 1}">
                    <!-- Configure the cols by number of columns provided by default w/ lg being max -->
                    <!-- Mobile Version -->
                    <div class="flex md:hidden
                        hover:bg-gray-100">
<!--                         @click="showRowModal(users[rowIndex])">-->
                        <a      :href="[permissions.can('show_users') ? editUserLink(user) : '']"
                                class="plain-link grow "
                                :class="[permissions.can('show_users') ? 'cursor-pointer' : 'cursor-not-allowed']">
                            <div class="ml-2 py-1 mb-1 grid grid-col-1"
                                 :class="[showNotifications ? 'sm:grid-cols-2' : '']">
                                <div>
                                    <div class="text-sm leading-5 font-medium text-gray-700 truncate">
                                        {{ user.display_name }}
                                    </div>
                                    <div class="ml-2 flex-col">
                                        <div class="my-1 flex items-center text-sm leading-5 text-gray-600">
                                            <span   :class="iconEmail" class="mr-2"></span>
                                            <span>
                                                {{ user.email }}
                                            </span>
                                        </div>
                                        <div class="my-1 flex items-center text-sm leading-5 text-gray-600">
                                            <span   :class="iconCompany" class="mr-2"></span>
                                            <span>
                                                {{ user.company }}
                                                <span    v-if="permissions.isSonicu()">({{ user.company_id }})</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Notifications (Only if we are on an actual Site) -->
                                <div    v-if="userHasNotifications(user)"
                                        class="hidden sm:min-w-64 sm:flex flex-col justify-center px-4 py-4 sm:px-6">
                                    <user-notifications-show    :notifications="user.notifications"
                                    ></user-notifications-show>
                                </div>
                            </div>
                        </a>
                        <div    v-if="permissions.can('login_as_other_user')"
                                class="cursor-pointer shrink flex max-w-12 items-center mr-8 justify-end"
                                @click="loginAsUser(user)"
                        >
                            <span   class="lnr icon-enter"
                                    :key="user.id"
                                    :data-tippy-content="loginAsUserTooltip + user.display_name"
                            ></span>
                        </div>
                    </div>

                    <!-- Desktop Version -->
                    <div class="hidden md:flex flex-row hover:bg-gray-100">
                        <div    @click="permissions.can('update_users') ? editUser(user) : showUser(user)"
                                @click.middle="permissions.can('update_users') ? editUser(user, true) : showUser(user)"
                                class="grow grid grid-cols-1 sm:grid-cols-1"
                                :class="[showNotifications ? 'md:grid-cols-3 xl:grid-cols-4' : 'md:grid-cols-2 xl:grid-cols-3',
                                         permissions.can('show_users') ? 'cursor-pointer' : 'cursor-not-allowed']">
                            <!-- Company (if sonicu w/ ID) -->
                            <div class="inline-block grow px-4 py-4 sm:px-6 col-span-1">
                                <div class="ml-2 py-1 mb-1">
                                    <div class=" flex-shrink-1">
                                        <div    class="pr-4 cursor-auto inline-block flex-col"
                                                @click.stop>
                                            <div class="text-sm leading-5 font-medium text-gray-700">
                                                {{ user.display_name }}
                                            </div>
                                            <div class="my-1 ml-2 flex items-center text-sm leading-5 text-gray-600">
                                                <span   :class="iconEmail" class="mr-2"></span>
                                                <span>
                                                    {{ user.email }}
                                                </span>
                                            </div>
                                            <div class="inline-block my-1 ml-2 flex items-center text-sm leading-5 text-gray-600">
                                                <span   :class="iconCompany" class="mr-2"></span>
                                                <span>
                                                    {{ user.company }}
                                                    <span    v-if="permissions.isSonicu()">({{ user.company_id }})</span>
                                                </span>
                                            </div>
                                            <div v-if="user.initial_admin_training_completed_at" class="my-1 ml-2 flex items-center text-sm leading-5 text-gray-600">
                                                <span   :class="iconAward" class="mr-2"></span>
                                                <span>
                                                    Training Completed!
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Notifications (Only if we are on an actual Site) -->
                            <div    v-if="userHasNotifications(user)"
                                    @click.stop
                                    @click.middle.stop
                                    class="hidden md:min-w-64 md:flex flex-col justify-center px-4 py-4 sm:px-6">
                                <user-notifications-show    :notifications="user.notifications"
                                ></user-notifications-show>
                            </div>

                            <!-- Permission Level -->
                            <div class="flex items-center grow px-4 py-4 sm:px-6">
                                <span>{{ user.permission_level }}</span>
                            </div>

                            <!-- Last Login -->
                            <div class="hidden xl:flex items-center grow px-4 py-4 sm:px-6">
                                <span>{{ user.last_login }}</span>
                            </div>

                        </div>

                        <!-- Edit Pencil Icon -->
                        <div    class="flex shrink items-center mr-8 cursor-pointer"
                                @click="permissions.can('update_users') ? editUser(user) : showUser(user)"
                                @click.middle="permissions.can('update_users') ? editUser(user) : showUser(user)">
                                <span   class="lnr icon-pencil"
                                ></span>
                        </div>

                        <div    v-if="permissions.can('login_as_other_user')"
                                class="cursor-pointer shrink flex max-w-12 items-center mr-8 justify-end"
                                @click.stop="loginAsUser(user)"
                        >
                            <span   v-if="isLoggingInAs !== user.id"
                                    class="lnr icon-enter"
                                    :key="user.id"
                                    :data-tippy-content="loginAsUserTooltip + user.display_name"
                            ></span>
                            <span   v-else
                                    :class="iconLoading"
                            ></span>
                        </div>
                    </div>
                </li>
                <li v-else>
                    <div class="flex flex-row items-center justify-center py-4">
                        <span>No Users Found</span>
                    </div>
                </li>
            </ul>
            <pagination     v-if="!loading"
                            :num-pages="pageInfo.pages"
                            v-model:page="page"
                            @update:page="updatePage($event)"
            ></pagination>
        </div>
    </div>
</template>

<script>

import axios from "axios"
import tippy from 'tippy.js';
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import Pagination from "@/components/Pagination"
import ItemsPerPageSelect from "@/components/ItemsPerPageSelect"
import FloatingInput from "@/components/elements/FloatingInput";
import Select2 from '@/components/elements/select2'
import GreenButton from "@/components/elements/green-button";
import UserNotificationsShow from "@/components/Users/UserNotificationsShow";
import ButtonBlueSecondary from "@/components/elements/buttons/ButtonBlueSecondary.vue";

const LOAD_DELAY = 250

export default {
    name: "UserList",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {
        ButtonBlueSecondary,
        UserNotificationsShow, GreenButton, Pagination, ItemsPerPageSelect, FloatingInput, Select2},
    props: {
        companyList: {},
    },
    data() {
        return {
            // showModal: false,
            search: '',
            _loadFunction: null,
            loading: false,
            users: [],
            showNotifications: false,
            selectedCompany: '',

            // Needed for Sorting on a table (consider extracting to a mixin)
            sortBy: '',
            sortDesc: false,
            requestNumber: 0,

            // Needed For any Paging (consider extracting to a mixin.
            page: 1,
            itemsPerPage: '100',
            pageInfo: {
                pages: 1,
                from: 1,
                to: 1,
                total: 1
            },

            // Tooltip info
            tippyInstance: null,
            loginAsUserTooltip: 'Login as ',
            isLoggingInAs: null,
        }
    },
    created() {
        this._loadFunction = _.debounce(() => {
            this.loading = true
            this.requestNumber++
            axios.get(this.company.buildCompanyApiInternalRoute(`users`), {
                params: {
                    companyId: this.company.getCompanyId(),
                    page: this.page,
                    search: this.search,
                    selectedCompany: this.selectedCompany,
                    perPage: this.itemsPerPage,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc,
                    requestNumber: this.requestNumber,
                },
            }).then(
                response => {
                    let data = response.data
                    if (data.meta.requestNumber !== `${this.requestNumber}`) {
                        return
                    }
                    this.users = data.data !== undefined ? data.data : []
                    if (data.meta) {
                        this.pageInfo = data.meta
                        this.pageInfo.pages = data.meta.last_page
                    }
                    else {
                        this.pageInfo = {
                            pages: 1,
                            from: 0,
                            to: 0,
                            total: 0,
                        }
                    }
                    if (this.page > this.pageInfo.pages) {
                        this.page = this.pageInfo.pages
                        this.loadData()
                    }
                }
            ).catch(
                error => {
                    this.users = []
                }
            ).then(
                () => {
                    this.loading = false
                    setTimeout(() => {
                        this.tippyInstance = tippy('[data-tippy-content]');
                    }, 100)
                }
            )
        }, LOAD_DELAY)
    },
    mounted() {
        this.loadData()
    },
    methods: {
        loadData() {
            this._loadFunction()
        },
        loginAsUser(user) {
            console.log(`Logging into ${user.display_name}`)
            if(user.id) {
                this.isLoggingInAs = user.id
                let data = {id: user.id};
                axios.get(`/SonicuTools/admin-login-as-user`, {
                    params: {
                        id: user.id,
                    },
                }).then(
                    response => {
                        alert(`You are now logged in as ${user.display_name}!  Please log out when you are finished testing whatever it is you're testing!`);
                        window.location.href = '/' + user.company_id + '/login';
                    }
                ).catch(error => {
                    console.log(error)
                    alert(`Error Logging into ${user.display_name}`)
                }).then(() => {
                    this.isLoggingInAs = null
                })
            }
        },
        userHasNotifications(user) {
            if (_.isNil(user.notifications)) {
                return false
            }
            this.showNotifications = true
            return true
        },
        showUser(user, newTab = false) {
            if (!this.permissions.can('show_users')) {
                return
            }
            let urlPartial = this.showUserLink(user)
            if (newTab) {
                window.open(`${urlPartial}`, '_blank')
            }
            else {
                window.location = urlPartial
            }
        },
        editUser(user, newTab = false) {
            if (!this.permissions.can('show_users')) {
                return
            }
            let urlPartial = this.editUserLink(user)
            if (newTab) {
                window.open(`${urlPartial}`, '_blank')
            }
            else {
                window.location = urlPartial
            }
        },
        showUserLink(user) {
            if (!this.permissions.can('show_users')) {
                return '#'
            }
            return this.company.buildCompanyRoute(`users/${user.id}`)
        },
        editUserLink(user) {
            if (!this.permissions.can('show_users')) {
                return '#'
            }
            return this.company.buildCompanyRoute(`users/${user.id}/edit`)
        },
        showModal() {

        },
        updatePage(page) {
            this.page = page
            this.loadData()
        },
        updateSort(by) {
            if (this.sortBy === by) {
                this.sortBy = this.sortDesc ? '' : this.sortBy
                this.sortDesc = !this.sortDesc
            }
            else {
                this.sortBy = by
                this.sortDesc = false
            }
            this.loadData()
        },
    },
    computed: {
        canLoadEditUser() {
            return this.permissions.can('show_users')
        },
    },
    watch: {
        search() {
            this.loadData()
        },
        itemsPerPage() {
            this.loadData()
        },
        selectedCompany() {
            this.loadData()
        },
    }
}
</script>

<style scoped>

</style>